/* Waïloa – sections éditoriales : apparitions, filtres cadeaux, store locator, UGC. Sans dépendance. */
(function () {
  'use strict';
  if (window.__wlePages) return; window.__wlePages = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Apparition au scroll ---------- */
  function reveal(root) {
    var els = (root || document).querySelectorAll('.wle [data-r]:not(.is-in), .wle-hero:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Sélection produits : filtres budget ---------- */
  function initProducts(sec) {
    var chips = sec.querySelectorAll('[data-budget]');
    if (!chips.length) return;
    var cards = sec.querySelectorAll('[data-price]'), empty = sec.querySelector('[data-empty]');
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var on = c.getAttribute('aria-pressed') !== 'true';
        chips.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        var min = on ? parseFloat(c.dataset.min || '0') : 0, max = on ? parseFloat(c.dataset.max || '0') : 0, n = 0;
        cards.forEach(function (card) {
          var p = parseFloat(card.dataset.price) / 100;
          var ok = !on || (p >= min && (!max || p <= max));
          card.hidden = !ok; if (ok) n++;
        });
        if (empty) empty.hidden = n > 0;
      });
    });
  }

  /* ---------- Store locator ---------- */
  function initLocator(sec) {
    var dataEl = sec.querySelector('[data-stores]');
    if (!dataEl) return;
    var stores = []; try { stores = JSON.parse(dataEl.textContent) || []; } catch (e) { stores = []; }
    stores.forEach(function (s) { s.lat = s.lat == null || s.lat === '' ? null : parseFloat(s.lat); s.lng = s.lng == null || s.lng === '' ? null : parseFloat(s.lng); });
    var T = {}; try { T = JSON.parse(sec.querySelector('[data-i18n]').textContent); } catch (e) {}
    var list = sec.querySelector('[data-list]'), status = sec.querySelector('[data-status]'), map = sec.querySelector('[data-map]');
    var form = sec.querySelector('[data-search]'), input = form && form.querySelector('input'), geo = sec.querySelector('[data-geo]');
    var typesEl = sec.querySelector('[data-types]');
    var origin = null, filterType = '', query = '', activeId = null;
    /* Consentement : la carte Google et la recherche d'adresse (OpenStreetMap) ne se chargent qu'après « Afficher la carte »,
       ou si le visiteur a déjà accepté les cookies via la bannière Shopify (window.Shopify.customerPrivacy). */
    var consentBtn = sec.querySelector('[data-map-ok]');
    function privacyOk() {
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (!cp || typeof cp.marketingAllowed !== 'function') return false;
        return !!(cp.marketingAllowed() && (typeof cp.preferencesProcessingAllowed !== 'function' || cp.preferencesProcessingAllowed()));
      } catch (e) { return false; }
    }
    var mapOk = false;
    try { mapOk = sessionStorage.getItem('wl-map-ok') === '1'; } catch (e) {}
    if (!mapOk) mapOk = privacyOk();

    function norm(s) { return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
    function hav(a, b) {
      var R = 6371, r = Math.PI / 180, dLat = (b.lat - a.lat) * r, dLng = (b.lng - a.lng) * r;
      var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * r) * Math.cos(b.lat * r) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * R * Math.asin(Math.sqrt(h));
    }
    function esc(s) { return (s || '').toString().replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function addr(s) { return [s.address, [s.zip, s.city].filter(Boolean).join(' '), s.country].filter(Boolean).join(', '); }
    function hasGeo(s) { return typeof s.lat === 'number' && typeof s.lng === 'number' && !isNaN(s.lat) && !isNaN(s.lng); }
    function mapQ(s) { return hasGeo(s) && !s.address ? s.lat + ',' + s.lng : (s.name + ', ' + addr(s)); }
    function setStatus(t) { if (status) status.textContent = t || ''; }

    // Filtres par type
    if (typesEl) {
      var types = [];
      stores.forEach(function (s) { if (s.type && types.indexOf(s.type) < 0) types.push(s.type); });
      if (types.length > 1) {
        var all = document.createElement('button'); all.type = 'button'; all.className = 'wle-chip'; all.textContent = T.all || 'Tous'; all.setAttribute('aria-pressed', 'true'); all.dataset.t = '';
        typesEl.appendChild(all);
        types.forEach(function (t) { var b = document.createElement('button'); b.type = 'button'; b.className = 'wle-chip'; b.textContent = t; b.dataset.t = t; b.setAttribute('aria-pressed', 'false'); typesEl.appendChild(b); });
        typesEl.addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b) return;
          filterType = b.dataset.t; typesEl.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          render();
        });
      } else { typesEl.hidden = true; }
    }

    function showMap(s) {
      if (!map || !s || !mapOk) return;
      var src = 'https://maps.google.com/maps?q=' + encodeURIComponent(mapQ(s)) + '&z=14&output=embed';
      var f = map.querySelector('iframe');
      if (!f) { map.innerHTML = ''; f = document.createElement('iframe'); f.loading = 'lazy'; f.referrerPolicy = 'no-referrer-when-downgrade'; f.title = T.map_title || 'Carte'; map.appendChild(f); }
      if (f.getAttribute('src') !== src) f.setAttribute('src', src);
    }

    function render() {
      var q = norm(query), rows = stores.map(function (s, i) { return { s: s, i: i, d: origin && hasGeo(s) ? hav(origin, s) : null }; });
      rows = rows.filter(function (r) { return !filterType || r.s.type === filterType; });
      if (q && !origin) {
        rows = rows.filter(function (r) { return norm([r.s.name, r.s.city, r.s.zip, r.s.address, r.s.country].join(' ')).indexOf(q) > -1; });
      }
      if (origin) rows.sort(function (a, b) { return (a.d == null ? 1e9 : a.d) - (b.d == null ? 1e9 : b.d); });
      list.innerHTML = '';
      if (!rows.length) {
        var li = document.createElement('li'); li.className = 'wle-loc__empty'; li.innerHTML = '<p class="wle-mute">' + esc(T.none || '') + '</p>'; list.appendChild(li);
        return;
      }
      rows.forEach(function (r, k) {
        var s = r.s, li = document.createElement('li'); li.className = 'wle-store'; li.dataset.id = r.i;
        var img = s.image ? '<img class="wle-store__img" src="' + esc(s.image) + '" alt="" loading="lazy" width="72" height="72">' : '<span class="wle-store__img wle-store__img--ph" aria-hidden="true">' + esc((s.name || '?').charAt(0)) + '</span>';
        var dist = r.d != null ? '<span class="wle-store__dist">' + (r.d < 10 ? r.d.toFixed(1) : Math.round(r.d)) + ' ' + esc(T.km || 'km') + '</span>' : '<span></span>';
        var links = '<a href="https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(mapQ(s)) + '" target="_blank" rel="noopener">' + esc(T.route || 'Itinéraire') + '</a>';
        if (s.phone) links += '<a href="tel:' + esc(s.phone.replace(/[^+\d]/g, '')) + '">' + esc(T.call || 'Appeler') + '</a>';
        if (s.site) links += '<a href="' + esc(s.site) + '" target="_blank" rel="noopener">' + esc(T.site || 'Site web') + '</a>';
        li.innerHTML = '<button type="button" class="wle-store__btn" aria-expanded="false">' + img +
          '<span>' + (s.type ? '<span class="wle-store__type">' + esc(s.type) + '</span>' : '') + '<span class="wle-store__name">' + esc(s.name) + '</span>' +
          '<span class="wle-store__meta">' + esc(addr(s)) + '</span></span>' + dist + '</button>' +
          '<div class="wle-store__more">' + (s.hours ? '<p class="wle-store__hours"><strong>' + esc(T.hours || '') + '</strong>\n' + esc(s.hours) + '</p>' : '') +
          (s.phone ? '<p class="wle-store__hours">' + esc(s.phone) + '</p>' : '') + '<div class="wle-store__links">' + links + '</div></div>';
        list.appendChild(li);
      });
      var first = list.querySelector('.wle-store');
      select(activeId != null && list.querySelector('[data-id="' + activeId + '"]') ? activeId : (first && first.dataset.id), false);
    }

    function select(id, scroll) {
      if (id == null) return;
      activeId = String(id);
      list.querySelectorAll('.wle-store').forEach(function (li) {
        var on = li.dataset.id === activeId; li.classList.toggle('is-active', on);
        li.querySelector('.wle-store__btn').setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      showMap(stores[+activeId]);
      if (scroll && window.innerWidth < 990 && map) map.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }

    list.addEventListener('click', function (e) {
      var b = e.target.closest('.wle-store__btn'); if (!b) return;
      select(b.parentNode.dataset.id, true);
    });

    function geocode(q) {
      var ctrl = window.AbortController ? new AbortController() : null;
      var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, 6000);
      var url = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&accept-language=' + encodeURIComponent(document.documentElement.lang || 'fr') + '&q=' + encodeURIComponent(q);
      return fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (j) {
        clearTimeout(t); if (j && j[0]) return { lat: parseFloat(j[0].lat), lng: parseFloat(j[0].lon) }; return null;
      }).catch(function () { clearTimeout(t); return null; });
    }

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      query = input.value.trim(); origin = null; activeId = null;
      if (!query) { setStatus(''); render(); return; }
      var anyGeo = stores.some(hasGeo);
      var direct = stores.filter(function (s) { return norm([s.name, s.city, s.zip].join(' ')).indexOf(norm(query)) > -1; });
      if (!anyGeo || direct.length) { setStatus(direct.length ? '' : (T.none || '')); render(); return; }
      if (!mapOk) { setStatus(T.consent_search || T.none || ''); render(); return; }
      setStatus(T.searching || '…');
      geocode(query).then(function (p) {
        if (p) { origin = p; setStatus((T.near || '') + ' ' + query); }
        else { setStatus(T.not_found || ''); }
        render();
      });
    });
    if (input) input.addEventListener('input', function () { if (!input.value.trim()) { query = ''; origin = null; setStatus(''); render(); } });

    if (geo) {
      if (!('geolocation' in navigator)) geo.hidden = true;
      geo.addEventListener('click', function () {
        setStatus(T.locating || '…');
        navigator.geolocation.getCurrentPosition(function (pos) {
          origin = { lat: pos.coords.latitude, lng: pos.coords.longitude }; query = ''; if (input) input.value = ''; activeId = null;
          setStatus(stores.some(hasGeo) ? (T.sorted || '') : (T.no_coords || ''));
          render();
        }, function () { setStatus(T.geo_error || ''); }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
      });
    }
    function allowMap(remember) {
      if (mapOk) return;
      mapOk = true;
      if (remember) { try { sessionStorage.setItem('wl-map-ok', '1'); } catch (e) {} }
      /* Recherche restée en attente du consentement : on la relance, sinon on affiche la boutique sélectionnée */
      if (query && !origin && form && input && input.value.trim() === query) {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
        return;
      }
      if (activeId == null) { var f0 = list.querySelector('.wle-store'); if (f0) activeId = f0.dataset.id; }
      if (activeId != null) showMap(stores[+activeId]);
    }
    if (consentBtn) consentBtn.addEventListener('click', function () { allowMap(true); });
    document.addEventListener('visitorConsentCollected', function () { if (privacyOk()) allowMap(false); });
    render();
  }

  /* ---------- UGC ---------- */
  function initUgc(sec) {
    var track = sec.querySelector('[data-track]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-ugc]'));
    var hoverCapable = window.matchMedia('(hover: hover)').matches;

    // Vidéos : lecture muette quand visibles (mobile) ou au survol (ordinateur)
    var vids = track.querySelectorAll('video');
    function play(v) { if (reduce) return; if (v.preload === 'none') { v.preload = 'metadata'; } var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    function pause(v) { try { v.pause(); } catch (e) {} }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          var v = x.target;
          if (x.isIntersecting && x.intersectionRatio > 0.6) { if (!hoverCapable) play(v); else v.preload = 'metadata'; }
          else pause(v);
        });
      }, { threshold: [0, 0.6] });
      vids.forEach(function (v) { io.observe(v); });
    }
    if (hoverCapable) cards.forEach(function (c) {
      var v = c.querySelector('video'); if (!v) return;
      c.addEventListener('mouseenter', function () { play(v); });
      c.addEventListener('mouseleave', function () { pause(v); });
    });

    // Navigation + glisser à la souris
    var prev = sec.querySelector('[data-prev]'), next = sec.querySelector('[data-next]');
    function step() { var it = track.querySelector('li'); return it ? it.getBoundingClientRect().width + 12 : 300; }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
    window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-drag'); } track.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { track.classList.remove('is-drag'); }, 0); });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

    // Lightbox
    var dlg = sec.querySelector('[data-lb]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var media = dlg.querySelector('[data-lb-media]'), body = dlg.querySelector('[data-lb-body]'), idx = 0;
    function open(i) {
      idx = (i + cards.length) % cards.length;
      var c = cards[idx], tpl = c.parentNode.querySelector('template');
      media.innerHTML = ''; body.innerHTML = '';
      if (tpl) {
        var frag = tpl.content.cloneNode(true);
        var m = frag.querySelector('[data-m]'), b = frag.querySelector('[data-b]');
        if (m) media.appendChild(m); if (b) body.appendChild(b);
      }
      var v = media.querySelector('video');
      if (!dlg.open) { dlg.showModal(); document.documentElement.classList.add('wle-lock'); }
      if (v) { v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play(); }); }
    }
    function close() { var v = media.querySelector('video'); if (v) v.pause(); dlg.close(); }
    dlg.addEventListener('close', function () { media.innerHTML = ''; document.documentElement.classList.remove('wle-lock'); });
    cards.forEach(function (c, i) { c.addEventListener('click', function () { open(i); }); });
    dlg.querySelector('[data-lb-x]').addEventListener('click', close);
    var p2 = dlg.querySelector('[data-lb-p]'), n2 = dlg.querySelector('[data-lb-n]');
    if (cards.length < 2) { p2.hidden = true; n2.hidden = true; }
    p2.addEventListener('click', function () { open(idx - 1); });
    n2.addEventListener('click', function () { open(idx + 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') open(idx + 1); if (e.key === 'ArrowLeft') open(idx - 1); });
  }

  function init(root) {
    root = root || document;
    reveal(root);
    root.querySelectorAll('[data-wle-products]').forEach(initProducts);
    root.querySelectorAll('[data-wle-locator]').forEach(initLocator);
    root.querySelectorAll('[data-wle-ugc]').forEach(initUgc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
